<template>
  <div class="box">
    <div class="box-body">
      <div class="row">
        <div class="col-md-3">
          <select2
            v-model="filters.auditable_type"
            :options="modelOptions"
            placeholder="Alle Datentypen"
            :settings="{allowClear: true}"
            @change="fetchLogs"
          ></select2>
        </div>
        <div class="col-md-3" v-if="filters.auditable_type">
          <select2
            v-model="filters.client_id"
            :options="clientOptions"
            placeholder="Alle Mandanten"
            :settings="{allowClear: true}"
            @change="fetchLogs"
          ></select2>
        </div>
        <div class="col-md-3">
          <input type="text" v-model="filters.auditable_id" class="form-control" placeholder="Nach ID filtern"
                 @keyup.enter="fetchLogs">
        </div>
        <div class="col-md-3">
          <div v-if="logs.last_page > 1" class="mb-3">
            <button @click="changePage(logs.current_page - 1)" :disabled="logs.current_page === 1"
                    class="btn btn-default btn-sm">Zurück
            </button>
            <span class="mx-2">Seite {{ logs.current_page }} von {{ logs.last_page }}</span>
            <button @click="changePage(logs.current_page + 1)" :disabled="logs.current_page === logs.last_page"
                    class="btn btn-default btn-sm">Vor
            </button>
          </div>
        </div>
      </div>
      <div style="position: relative;">
        <div v-if="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.7); z-index: 10; display: flex; align-items: center; justify-content: center;">
          <i class="fa fa-spinner fa-pulse fa-2x text-muted"></i>
        </div>
      <table class="table table-striped mt-3" style="table-layout: fixed; width: 100%;">
        <thead>
        <tr>
          <th></th>
          <th>ID</th>
          <th>Typ</th>
          <th>Mandant</th>
          <th>Ereignis</th>
          <th>Datum</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="log in logs.data">
          <tr :key="'row-' + log.id" @click="toggleRow(log)" style="cursor: pointer;">
            <td><i :class="log.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i></td>
            <td>{{ log.auditable_id }}</td>
            <td>{{ models[log.auditable_type] || log.auditable_type }}</td>
            <td>{{ log.client_id || '-' }}</td>
            <td>{{ log.event_type }}</td>
            <td>{{ formatDate(log.created_at) }}</td>
          </tr>
          <tr v-if="log.expanded" :key="'details-' + log.id">
            <td colspan="6" style="padding: 0; border: none;">
              <table class="table table-bordered table-condensed" style="margin: 0; width: 100%; table-layout: fixed;">
                <thead>
                <tr>
                  <th style="width: 20%;">Attribut</th>
                  <th style="width: 40%;">Alt</th>
                  <th style="width: 40%;">Neu</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="log.changes && log.changes.new">
                  <tr v-for="(value, key) in log.changes.new" :key="key">
                    <td style="word-wrap: break-word;"><strong>{{ key }}</strong></td>
                    <td style="word-wrap: break-word;">{{ log.changes.old ? log.changes.old[key] : '' }}</td>
                    <td style="word-wrap: break-word;">{{ value }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="3" style="word-wrap: break-word;">-</td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      models: {},
      clients: [],
      loading: false,
      logs: {data: [], current_page: 1, last_page: 1},
      filters: {
        auditable_type: '',
        client_id: '',
        auditable_id: ''
      }
    }
  },
  computed: {
    modelOptions() {
      return [
        {id: '', text: 'Alle Datentypen'},
        ...Object.entries(this.models).map(([type, name]) => ({id: type, text: name}))
      ];
    },
    clientOptions() {
      return [
        {id: '', text: 'Alle Mandanten'},
        ...this.clients.map(client => ({id: client.id, text: client.name}))
      ];
    }
  },
  mounted() {
    this.fetchModels();
    this.fetchClients();
    this.fetchLogs();
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    fetchModels() {
      axios.get('/backend/audit_logs/models').then(response => {
        this.models = response.data.models;
      });
    },
    fetchClients() {
      axios.get('/backend/audit_logs/clients').then(response => {
        this.clients = response.data.clients;
      });
    },
    fetchLogs(page = 1) {
      this.loading = true;
      axios.get('/backend/audit_logs/data', {params: {...this.filters, page}})
        .then(response => {
          this.logs = {
            ...response.data,
            data: response.data.data.map(log => ({...log, expanded: false}))
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.fetchLogs(page);
    },
    toggleRow(log) {
      this.$set(log, 'expanded', !log.expanded);
    }
  }
}
</script>
